import { render } from "./Location.vue?vue&type=template&id=0fdce37a"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Location.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0fdce37a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0fdce37a', __exports__)) {
    api.reload('0fdce37a', __exports__)
  }
  
  module.hot.accept("./Location.vue?vue&type=template&id=0fdce37a", () => {
    api.rerender('0fdce37a', render)
  })

}


export default __exports__